export class TabErrorCount {
  tabName!: string;
  tabErrorCount!: number;
}
